import { render, staticRenderFns } from "./BranchDebt.vue?vue&type=template&id=ae156f08&scoped=true"
import script from "./BranchDebt.vue?vue&type=script&lang=js"
export * from "./BranchDebt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae156f08",
  null
  
)

export default component.exports